// Android's system captive-portal WebView can mount a page before the query
// string settles, so a one-time snapshot at mount is unreliable — read the URL
// fresh whenever it's needed, and stash it in sessionStorage as a fallback in
// case the params are gone by the time they're actually used.
export function getHotspotParams() {
  const params = new URLSearchParams(window.location.search);
  const mac = params.get("mac");
  const ip = params.get("ip");
  if (mac || ip) {
    const stored = { mac, ip };
    try { sessionStorage.setItem("nhp_hotspot_params", JSON.stringify(stored)); } catch { /* storage blocked — we still have this call's values from the URL */ }
    return stored;
  }
  try {
    return JSON.parse(sessionStorage.getItem("nhp_hotspot_params")) || { mac: null, ip: null };
  } catch {
    return { mac: null, ip: null };
  }
}
